import { createFileRoute } from '@tanstack/react-router';

type SearchParams = {
  email?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/password-reset')({
  validateSearch: (search: Partial<SearchParams>): SearchParams => search,
});
